<template>
  <!-- 一个设备对象的组件 -->
  <div>
    <!-- 拖拽抖动的样式，最外层加一层div是为了  避免拖拽排序时的动画被 抖动的动画覆盖 -->
    <div :class="
        $store.state.configinfo.objectMoveState
          ? 'device_wraper_paixu_dou_dong'
          : ''
      ">
      <div class="device_item_wraper  public_control_yinying_xiaoguo"
           :class="
          deviceState === '开' || deviceState === '开/升' || deviceState === ''
            ? 'device_item_wraper_open'
            : 'device_item_wraper_close'
        "
           @click="deviceBtnClickHandle"
           @contextmenu.prevent="deviceRightClickBtnHandle">
        <!-- 上部分的样式 -->
        <div class="device_item_top">
          <!-- 左上角的图片样式 -->
          <img :src="oneDevice.iconUrl"
               alt
               class="device_item_top_icon" />
          <!-- 右上角开关样式  viewType === ''这个参数用来判断设备显示的类型，  空的时候，代表是正常的控制页面类型-->
          <span v-if="deviceViewType === '开关样式' && viewType === ''"
                class="device_item_top_state">
            <img v-show="!oneDevice.openState"
                 src="~assets/img/controlpublic/changyong_guan.png"
                 alt
                 class="device_item_top_state_img" />
            <img v-show="oneDevice.openState"
                 src="~assets/img/controlpublic/changyong_kai.png"
                 alt
                 class="device_item_top_state_img" />
          </span>
          <!-- 右上角调光样式 -->
          <span v-else-if="deviceViewType === '调光样式' && viewType === ''"
                class="device_item_top_text">{{ oneDevice.openStateValue }}%</span>
          <!-- 通用文本样式 -->
          <span v-else-if="viewType === ''"
                class="device_item_top_text">{{
            deviceViewType
          }}</span>
        </div>
        <!-- 中部分的样式 -->
        <div class="device_item_remark">{{ oneDevice.remark }}</div>
        <!-- 下部分的样式 -->
        <div class="device_item_region_state">
          <span class="device_item_region_name">{{
            oneDevice.regionName
          }}</span>

          <!-- 添加常用页面设备  类型显示勾选序号 -->

          <div v-if="viewType === 'configDevice' && oneDevice.followOrder != 0"
               class="device_item_sort_index"
               :class="
              oneDevice.followState === 1
                ? 'scene_item_sort_index_font_big'
                : ''
            ">
            {{ oneDevice.followOrder }}
          </div>
          <!-- 添加常用页面设备  类型显示勾选状态 -->
          <img v-if="viewType === 'configDevice'"
               v-show="oneDevice.followState === 0"
               src="~assets/img/config/weixuan.png"
               alt />
          <img v-if="viewType === 'configDevice'"
               v-show="oneDevice.followState === 1"
               src="~assets/img/config/xuanzhong.png"
               alt />

          <!-- 正常控制页面类型显示 状态 -->
          <span v-if="viewType === ''"
                class="device_item_state_text">{{
            deviceState
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  judgeActivePage,
  publicFadeInOut,
  jieMianStateJudge
} from 'common/tool'
import { controlBtnRequestHandle } from 'components/content/control-toast/control-toast-classify/device-public-js'
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data () {
    return {
      userControlData: {
        ////部分没有二级页面的数据需要
        openState: this.oneDevice.openState, ///1开 或0关
        openStateValue: this.oneDevice.openStateValue, //无用
        openStateValue1: this.oneDevice.openStateValue1, ///无用
        openStateValue2: this.oneDevice.openStateValue2 ///无用
      }
    }
  },
  props: {
    oneDevice: Object,
    viewType: {
      type: String,
      default: ''
    }
  },
  methods: {
    deviceBtnClickHandle () {
      //设备点击时弹出控制窗
      ///判断当前设备类型  是否和后面的'01' , '021' , '05'相同，相同返回true
      // viewType === ''这个参数用来判断设备显示的类型，  空的时候，代表是正常的控制页面类型-
      if (!jieMianStateJudge()) return ///界面管理状态判断

      if (this.viewType === '') {
        if (
          publicDeviceTypeJudge(this.oneDevice.productCode, '01', '021', '05', '048')  //代号 20231207-1
        ) {
          deviceStateFlip(this.userControlData) ///对设备的状态0和1进行翻转
          controlBtnRequestHandle(this.userControlData, this.oneDevice) ///控制请求服务端的公共方法
          return
        } else {
          this.$showControlToast('device', this.oneDevice)
          this.$store.dispatch('asyUpdataobjData', this.oneDevice) ///异步提交二级页面展示的数据，用于二级页面的实时状态更新 20200405添加
        }
      } else if (this.viewType === 'configDevice') {
        ////当前处于勾选常用设备的页面
        if (this.oneDevice.followState === 1) {
          ///取消收藏
          this.$emit('followOrderCompuder', this.oneDevice.followOrder)
          this.oneDevice.followState = 0
          this.oneDevice.followOrder = 0
        } else {
          ///添加收藏
          this.$emit('followOrderCompuInc', this.oneDevice)

          this.oneDevice.followState = 1
        }
      }
    },
    deviceRightClickBtnHandle () {
      // 主账号判断  0主账号
      console.log('当前是子账号不支持')
      console.log('设备对象右击了')
      if (!jieMianStateJudge()) return ///界面管理状态判断
      if (sessionStorage.getItem('userType') != '0') return

      this.$showTipsToast(11, this.oneDevice)
    }
  },
  watch: {
    oneDevice: {
      handler (newValue, oldValue) {
        console.log('单个数据发生了改变')

        this.useroneDevice = newValue;
        // 这里与PC的处理逻辑不同,这里是用户点下之后就翻转更新显示状态,然后再根据实际返回结果,恢复原来状态,或保持成功状态
        //解决 控制页面接收到socket数据之后  显示发生变化  实际在点击控制时 状态翻转出现的BUG
        this.userControlData.openState = newValue.openState;
        this.userControlData.openStateValue = newValue.openStateValue;
        this.userControlData.openStateValue1 = newValue.openStateValue1;
        this.userControlData.openStateValue2 = newValue.openStateValue2;


        if (this.$store.state.publicinfo.objData.deviceId) {
          if (
            this.$store.state.publicinfo.objData.deviceId === newValue.deviceId
          ) {
            console.log('有一个二级页面需要更新')
            console.log(newValue)
            ////发送一个事件句柄消息到 二级控制页面用于状态实时同步更新 （不能用VUEx暂时搞不不明白）
            window.dispatchEvent(
              new CustomEvent('control2PageUpdata', {
                detail: {
                  data: newValue
                }
              })
            )
            // this.bus.$emit('control2PageUpdata', newValue)
            // this.$store.dispatch('asyUpdataobjData', this.oneDevice) ///异步提交二级页
          }
        } else {
          console.log('单个数据发生了改变,当前二级控制页面未打开不需要更新')
        }
      },
      deep: true //深度监听,监听数组的第二层数据变化
    }
  },
  computed: {
    deviceState () {
      //判断设备类型，决定右下角显示的样式
      return deviceTypeJudge1(this.oneDevice)
    },
    deviceViewType () {
      ///判断设备类型决定右上角显示的样式
      return deviceTypeJudge(this.oneDevice)
    }
  }
}
</script>

<style>
.device_item_wraper {
  width: 135px;
  height: 107px;

  border-radius: 10px;
  box-sizing: border-box;

  padding: 13px;

  flex: 0 0 auto;

  margin: 20px 50px 20px 0px;

  cursor: pointer;
}
.device_item_top_icon {
  width: 34px;
  height: 34px;
}
.device_item_wraper_open {
  background: rgba(255, 255, 255, 1);
}

.device_item_wraper_close {
  background: rgba(255, 255, 255, 0.8);
}

.device_item_top {
  position: relative;
}

.device_item_top_state {
  display: block;
  height: 25px;
  width: 49px;
  float: right;
}

.device_item_top_state_img {
  height: 100%;
  width: 100%;
}

.device_item_remark {
  font-size: 16px;
  color: #282828;
}

.device_item_region_state {
  position: relative;
}
/* 常用设备页面的勾选图片样式 */
.device_item_region_state img {
  display: inline-block;
  width: 24px;
  height: 24px;

  position: absolute;
  top: -5px;
  right: 0px;
}

.device_item_sort_index {
  display: inline-block;
  position: absolute;
  top: -61px;
  right: -7px;

  font-size: 16px;
  width: 40px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: var(--primary-color);
}

.device_item_region_name {
  display: inline-block;
  width: 75px;
  /**打点显示 同时避免影响后续的span */
  color: #999999;
  font-size: 14px;
}

.device_item_state_text {
  color: var(--primary-color);
  font-size: 14px;
  float: right;
}

.device_item_top_text {
  color: var(--primary-color);
  font-size: 14px;
  float: right;
}

/* 打点 */

.device_item_remark {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.device_item_region_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
